<template>
    <v-dialog v-model="open" max-width="400" persistent>
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                {{ titleProp }}
                <v-btn icon @click="$emit('close', false)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text v-if="descriptionProp" class="body-2 pb-2">
                {{ descriptionProp }}
            </v-card-text>

            <v-card-actions class="pa-4 pt-2">
                <v-spacer />
                <v-btn text @click="$emit('close', false)">Cancel</v-btn>
                <v-btn color="primary" @click="$emit('close', true)">Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'confirm-dialog',
    props: {
        titleProp: {
            type: String,
            default: 'Confirm',
        },
        descriptionProp: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        open: true,
    }),
};
</script>
